import React from "react";
import Gobackbuton from "../../Components/Gobackbutton/Gobackbuton";
import Search from "../../Components/Search/Search";
const Product = () => {
  return (
    <div className="background">
      <div className="top-row poppins-font product">
        <Gobackbuton />
        <h2 className="product-title">Product</h2>
        <Search className="product_input" placeholder="Search" />
      </div>
      <div className="double_swich">
        <div className="swichs">
          <div className="swich-title">Apply coupon to all items?</div>
          <label class="switch">
            <input type="checkbox"></input>
            <span class="slider round"></span>
          </label>
        </div>
        <div className="swichs2">
          <div className="swich-title">Apply coupon to all customizations?</div>
          <label class="switch">
            <input type="checkbox"></input>
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Product;
